<template>
    <div class="modal fade show add-note-modal" aria-labelledby="addNewCardTitle">
        <div class="modal-dialog modal-dialog-centered modal-lg" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center px-1 my-1 align-item-center">
                            <h1 class="mb-0">New Appointment</h1>
                            <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0">
                
                <div class="modal-body">
                    <form @submit.prevent="saveOPDBilling"> 
                        <div>
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-label">Consultant</label>
                                    <v-select placeholder="Select consultant"
                                        v-model="formData.service_resource_id"
                                        :options="serviceResources"
                                        :reduce="name => name.id"
                                        label="name"
                                        @option:selected="onSelectServiceResource"
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">Service Serial No</label>
                                    <vField
                                        name="service_serial_no"
                                        type="text"
                                        class="form-control"
                                        v-model="formData.service_serial_no"
                                        readonly=""
                                    />
                                </div>
                            </div>
                            <div class="row mb-2 mt-2 d-flex align-items-center">
                                <div class="col-md-6">
                                    <input
                                        @change="onSelectServiceResource"
                                        v-model="formData.date"
                                        name="datetime"
                                        type="datetime-local"
                                        class="form-control"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <AsyncSelect
                                        placeholder="Patient Name, ID, Mobile No"
                                        v-model="selectedPatient"
                                        :api-service="fetchContactProfiles"
                                        :additional-query="additionalQuery"
                                        :format-label="formatPatientLabel"
                                        :additional-option="additionalOption"
                                    />
                                </div>
                                <div class="col-md-2">
                                    <button
                                        type="button"
                                        class="btn btn-primary new-patient-action-btn"
                                        @click="openPatientAddModal"
                                    >New Patient
                                    </button>
                                </div>
                                <div class="col-md-4">
                                    <input
                                        v-model="patientSerialNo"
                                        type="number"
                                        placeholder="Patient serial no"
                                        class="form-control"
                                        @keyup="searchPatientById"
                                    />
                                </div>
                            </div>
                            <div class="row h-40 mb-3 mt-1">
                                <div class="col-md-6">
                                    <label class="form-label">Select Referrer:</label>
                                    <AsyncSelect
                                        placeholder="Select Referrer"
                                        v-model="formData.referrer_id"
                                        :api-service="fetchContactProfiles"
                                        :additional-query="{ type: 'agent' }"
                                        :format-label="formatPatientLabel"
                                        :reduce="referrer => referrer.id"
                                    />
                                </div>
                            </div>
                            <div class="row py-1 justify-content-between">
                                <div class="col-md-6">
                                    <div class="mb-1">
                                        <label class="form-label" for="fullName">Full Name</label>
                                        <vField
                                            name="full_name"
                                            type="text"
                                            class="form-control"
                                            v-model="patient.full_name"
                                            readonly=""
                                        />
                                    </div>
                                    <div class="mb-1">
                                        <label class="form-label" for="patientId">Patient ID</label>
                                        <vField
                                            name="patient_id"
                                            type="text"
                                            class="form-control"
                                            v-model="patient.serial_no"
                                            readonly=""
                                        />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-1">
                                        <div class="row">
                                          <div class="col-6">
                                            <label class="form-label" for="mobileNo">Mobile No</label>
                                          </div>
                                          <div class="col-6 text-end" v-if="patient.mobile_no">
                                            <input type="checkbox" v-model="formData.is_sms" class="form-check-input">
                                            <label class="form-check-label" for="sendSms">Send SMS</label>
                                          </div>
                                        </div>
                                        <vField
                                            name="mobile"
                                            type="text"
                                            class="form-control"
                                            v-model="patient.mobile_no"
                                            readonly=""
                                        />
                                    </div>
                                    <div class="d-flex gap-1">
                                        <div class="mb-1 col-md-5">
                                            <label class="form-label" for="age">Age</label>
                                            <vField
                                                name="birthday"
                                                type="text"
                                                class="form-control"
                                                v-model="patient.age"
                                                readonly=""
                                            />
                                        </div>
                                        <div class="mb-1 col-6">
                                            <label class="form-label" for="gender">Gender</label>
                                            <vField
                                                name="gender"
                                                type="text"
                                                class="capitalize form-control"
                                                v-model="patient.gender"
                                                readonly=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-center">
                                <hr>
                                <SubmitCancelBtn
                                    class="text-center"
                                    @onCancel="closeModal"
                                    :loading="loading"
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <AddPatientModal
            v-if="$store.state.isModalOpenTwo"
            :doctors="doctors"
            @onCreateProfile="onCreateProfile"
        />

        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import {computed, inject, onMounted, reactive, ref, watch} from 'vue';
import {useRoute, useRouter} from "vue-router";
import handleHospital from "@/services/modules/hospital";
import handleDentalOs from "@/services/modules/dental-os/dentalOs";
import Loader from "@/components/atom/LoaderComponent.vue";
import handleInventory from "@/services/modules/inventory";
import handleVoucherNo from "@/services/modules/refNumber";
import AddPatientModal from '@/components/molecule/company/hospital/AddPatientModal'
import { useStore } from 'vuex';
import handleContact from '@/services/modules/contact'
import handleCompany from "@/services/modules/company";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';
import { getCurrentDateTime } from '@/services/utils/global.js'

const { fetchContactProfiles } = handleContact()
const { fetchCompanyInfo } = handleCompany();
const { formatPatientLabel } = useAsyncDropdownHelper()
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const $route = useRoute();
const $router = useRouter();
const $store = useStore();

const emit = defineEmits(['onSubmit']);

const loading = ref(false);
const company = ref({});
const patientSerialNo = ref(null);
const additionalQuery = {
    type: "patient"
}

const openPatientAddModal = () => {
    $store.state.isModalOpenTwo = true
}

const closeModal = () => {
    $store.state.isModalOpen = false
}

const onCreateProfile = async (profileInfo) => {
    selectedPatient.value = {
        id: profileInfo.id,
        name: profileInfo.full_name
    };

    additionalOption.value.push(selectedPatient.value)
    formData.value.contact_profile_id = profileInfo.id;
    await onSelectPatient(profileInfo);
}

const formData = ref({
    account_head_id: null,
    account_payable_head_id: null,
    vat_payable_account_head_id: null,
    doctor_contact_profile_id: null,
    bill_number: null,
    is_sms: false,
    service_specification: null,
    service_resource_id: null,
    resource_description_id: null,
    contact_profile_id: null,
    referrer_id: null,
    adjustment_amount: 0,
    discount_head_id: null,
    date: getCurrentDateTime(),
    service_end_date_time: null,
    service_serial_no: '',
    has_item_detail: false,
    account_details: [],
    cost_of_sales_price: '',
    cost_of_sales_account_head_id: null,
    description: 'OPD service bill',
    sale_type: 'opd_invoice',
    receipt_type: 'opd_invoice',
    status: 'active',

    payment_bill_number: null,
    mop_account_head_id: null,
    receipt_reference: '',
    payment: 0,
})

const oldSerialNo = ref(null);
const additionalOption = ref([])
const serviceResources = ref([])
const patient = ref({});
const selectedPatient = ref(null);
const doctors = reactive([]);
const homeContent = ref({
    resource_type: {},
    resource_specifications: {}
})

const companyId = computed(() => $route.params.companyId);
const { fetchServiceSerialNo, removeServiceSerialNo } = handleVoucherNo()
const {fetchHome} = handleInventory();
const { storeBill } = handleDentalOs();
const {fetchPatientDetails, fetchServiceResourceList, dateOfBarthConvertToAge, fetchPatientDetailsBySerial} = handleHospital()

const onSelectServiceResource = async (selectedServiceResource) => {
    if (!!oldSerialNo.value) {
        await removeServiceSerialNo(oldSerialNo.value)
    }

    formData.value.doctor_contact_profile_id = selectedServiceResource.contact_profile_id
    let queryParams = `?company_id=${companyId.value}&voucher_type=service_sl_no&service_resource_id=${formData.value.service_resource_id}&date=${formData.value.date}`;
    let res = await fetchServiceSerialNo(queryParams);
    formData.value.service_serial_no = res.data

    oldSerialNo.value = {
        company_id: companyId.value,
        service_resource_id: formData.value.service_resource_id,
        serial_no: res.data,
        date: formData.value.date
    }
}

const searchPatientById = async () => {

    if(!patientSerialNo.value) return;
    
    patient.value = {}
    loading.value = true;
    const companyQuery = `?company_id=${companyId.value}`

    await fetchPatientDetailsBySerial(companyQuery, patientSerialNo.value).then((res) => {

        if (!res.status) {
            return showError(res.message)
        }

        patient.value = res.data;
        selectedPatient.value = null;

        formData.value.contact_profile_id = patient.value.id;

        if (patient.value.birthday) {
            const {year, month, day} = dateOfBarthConvertToAge(patient.value.birthday)
            patient.value.age = `${year}Y, ${month}M, ${day}D`
        }
    })

    loading.value = false;
}

const onSelectPatient = async (profileInfo) => {

    patientSerialNo.value = null;
    const companyQuery = `?company_id=${companyId.value}`

    await fetchPatientDetails(companyQuery, profileInfo.id).then((res) => {
        if (!res.status) {
            return showError(res.message)
        }

        patient.value = res.data;

        if (patient.value.birthday) {
            const {year, month, day} = dateOfBarthConvertToAge(patient.value.birthday)
            patient.value.age = `${year}Y, ${month}M, ${day}D`
        }
    })
}

const saveOPDBilling = async () => {

    loading.value = true

    const formattedData = formatData();

    await storeBill(formattedData).then(res => {
        loading.value = false
        if (!res.status) {
            return showError(res.message)
        }
        showSuccess(res.message)
        closeModal();
        resetForm();
        emit('onSubmit');
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false;
        oldSerialNo.value = null;
    })
}

const resetForm = () => {
    formData.value.doctor_contact_profile_id = null;
    formData.value.bill_number = null;
    formData.value.service_specification = null;
    formData.value.service_resource_id = null;
    formData.value.resource_description_id = null;
    formData.value.contact_profile_id = null;
    formData.value.date = getCurrentDateTime();
    formData.value.service_end_date_time = null;
    formData.value.service_serial_no = '';
    formData.value.has_item_detail = false;
    formData.value.is_sms = false;
    formData.value.account_details = [];
    formData.value.cost_of_sales_price = '';
    formData.value.cost_of_sales_account_head_id = null;
    formData.value.description = 'OPD service bill';
    formData.value.status = 'active';
    formData.value.payment_status = 'paid';

    formData.value.payment_bill_number = null;
    formData.value.receipt_reference = '';
    formData.value.paid_amount = 0;

    patient.value = {};
    selectedPatient.value = null;
}

const formatData = () => {
    const formattedData = structuredClone(formData.value);
    formattedData.company_id = companyId.value
    return formattedData;
}

watch(selectedPatient, (newValue) => {
    if (newValue) {
        formData.value.contact_profile_id = newValue.id;
        onSelectPatient(newValue)
    }
})

const getQuery = () => {
    return `?company_id=${companyId.value}`
}

const getHomeContent = async () => {
    await fetchHome().then(({data}) => {
            if (data) {
                const {resource_type, resource_specifications} = data;
                homeContent.value.resource_type = resource_type;
                homeContent.value.resource_specifications = resource_specifications;
            }
        })
}

const getServiceResourceList = async () => {
    await fetchServiceResourceList(getQuery()).then(({data}) => {
        if (data) serviceResources.value = data
    })
}

onMounted(async () => {
    loading.value = true

    let companyQuery = getQuery()

    await Promise.all([
        getHomeContent(),
        fetchContactProfiles(companyQuery + `&type=doctor`).then((res) => {
            if(res.status) doctors.push(...res.data)
        }),
        getServiceResourceList(),
        fetchCompanyInfo(companyId.value).then((res) => {
            company.value = res.data
        })
    ]).then(() => {
        loading.value = false;
    }).catch((err) => {
        loading.value = false
    });
})
</script>


<style scoped>
.add-note-modal {
    display: block; 
    background: #1c1d1c33
}
</style>